import { METAS } from "./constants";

/**
 * Generate reducer.
 *
 * @param {Object} initialState
 * @param {Object} handlers
 * @returns {function}
 */
export function createReducer(initialState: Object, handlers: Object) {
  return function reducer(state: Object = initialState, action: Object) {
    if ({}.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

/**
 * Generate format to money.
 *
 * @param {number} amount
 * @param {number} decimalCount
 * @param {string} decimal
 * @param {string} thousands
 * @returns {function}
 */
export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};

/**
 * Generates chunks
 *
 * @param {array} array
 * @param {number} chunkSuze
 * @returns {function}
 */
export function chunk(array, chunkSize = 2) {
  var R = [];
  for (var i = 0; i < array.length; i += chunkSize)
    R.push(array.slice(i, i + chunkSize));
  return R;
}

export function toDecimals(el, decimals = 2) {
  try {
    let number = el;
    if (typeof el === 'string') {
      number = parseFloat(el);
    }
    return (number).toFixed(decimals);
  } catch($e) {
    return 0;
  }
}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function getUrlParameter (name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  let results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export function uniqByLocal(a, key) {
  let seen = new Set();
  return a.filter(item => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
  });
};

export function toMarcaFormatted(marca) {
  const list = {
    'citroen': 'citroën',
    'vehiculos en oferta': 'ofertas'
  };

  const marcaLowercase = marca.toLocaleLowerCase();
  return list[marcaLowercase] || marca;
}

export function toFinanceFormatted(marca) {
  const list = {
    'Carrofacil': 'Carrofácil'
  };

  return list[marca] || marca;
}

export function capitalize(word) {
  const lower = word.toLocaleLowerCase();
  return word.charAt(0).toUpperCase() 
    + lower.slice(1)
}

export function IsOnlyNumbers(value) {
  const reg = new RegExp('^[0-9]+$');
  const hasOnlyNumbers = reg.test(value);
  return hasOnlyNumbers;
}

export function scrollToTop (duration) {
  // cancel if already on top
  if (document.scrollingElement.scrollTop === 0) return;

  const cosParameter = document.scrollingElement.scrollTop / 2;
  let scrollCount = 0, oldTimestamp = null;

  function step (newTimestamp) {
      if (oldTimestamp !== null) {
          // if duration is 0 scrollCount will be Infinity
          scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
          if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = 0;
          document.scrollingElement.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount);
      }
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}

export function getMeta(match) {
  const lowerMatch = match.toLocaleLowerCase();
  var keywoards = METAS[lowerMatch] || METAS["_"];
  return keywoards?.keywoard;
}

export function getTitle(match) {
  const lowerMatch = match.toLocaleLowerCase();
  var keywoards = METAS[lowerMatch] || METAS["_"];
  return keywoards?.title;
}

export function getDescription(match) {
  const lowerMatch = match.toLocaleLowerCase();
  var keywoards = METAS[lowerMatch] || METAS["_"];
  return keywoards?.description;
}

/**
 * Generate a pop up window in the center of the screen.
 *
 * @param {string} url
 * @param {number} width
 * @param {number} height
 */
 export function popUpWin(url, width, height) {
  try {
    var leftPosition, topPosition;
    //Allow for borders.
    leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
    //Allow for title and status bars.
    topPosition = (window.screen.height / 2) - ((height / 2) + 50);
    //Open the window.
    window.open(url, "Window2",
    "status=no,height=" + height + ",width=" + width + ",resizable=yes,left="
    + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY="
    + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");
  } catch (e) {
    console.log(e)
  }
};

export const postData = (path, params, method) => {
  // Create form
  const hidden_form = document.createElement('form');
  // Set method to post by default
  hidden_form.method = method || 'post';
  // Set path
  hidden_form.action = path;
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hidden_input = document.createElement
          ('input');
      hidden_input.type = 'hidden';
      hidden_input.name = key;
      hidden_input.value = params[key];
      hidden_form.appendChild(hidden_input);
    }
  }

  document.body.appendChild(hidden_form);
  hidden_form.submit();
}